
import $profile from 'stores/profile'
export default {
  props: {
    copying: {
      type: Boolean,
      default: false
    },
    owner: {
      type: Object,
      required: true
    }
  },
  emits: ['cancel', 'duplicate'],
  computed: {
    name(){
      if (this.owner.first_name && this.owner.last_name) {
        return `${this.owner.first_name} ${this.owner.last_name}`
      }
      return this.owner.name
    },
    email(){
      return this.owner.email
    },
    avatar_url(){
      return this.owner.avatar_url
    },
    self_chat(){
      return $profile.id === this.owner.id
    }
  },
}
